<h3>
    <mat-icon>priority_high</mat-icon>IMPORTANT -- Confirm placement of these Cards &amp; Binders from your supply and
    then click the Confirm button
    below
</h3>

<mat-divider></mat-divider>

<span *ngIf="!order">
    <mat-spinner matPrefix [diameter]="30" style="display:inline-block; margin-top: 1em;"></mat-spinner>
    <p matSuffix style="display:inline-block;">Loading Sales Order...</p>
</span>
<span *ngFor="let kvp of review | keyvalue">
    <h4>{{kvp.key}} - {{binders.BinderShelf[kvp.key].Description}}</h4>
    <mat-list class="card-list">
        <mat-list-item *ngFor="let card of kvp.value">
            <span>{{card.InventoryID}} - {{card.Description}}</span>
            <span></span>
            <button mat-icon-button>
                <mat-icon [matMenuTriggerFor]="cardMenu">more_vert</mat-icon>
            </button>
            <mat-menu #cardMenu="matMenu">
                <button mat-menu-item (click)="shipCardFromWarehouse(card.InventoryID)">Ship from Warehouse</button>
            </mat-menu>
        </mat-list-item>
    </mat-list>
</span>

<mat-divider></mat-divider>

<button mat-raised-button color="primary" style="margin-top:0.5em; width: 95vw;" (click)="confirmRepPlacement()">Confirm
    Cards/Binders are Placed</button>